const FILTERS = {
  "terraform-vsp-one-block": {
    vsp_one_block_terraform_provider: {
      title: "VSP One Block Terraform Provider",
      icon: "server.png",
    },
    terraform: {
      title: "Terraform",
      icon: "server.png",
    },
    golang: {
      title: "Golang",
      icon: "server.png",
    },
    storage: {
      title: "Storage",
      icon: "os.png",
    },
  },
};
export default FILTERS;
